import { customCreateQuote } from "@iewcasia/Services/CustomQuoteGuestService";
import { clearInitialSiteLoadQuery, getInitialSiteLoadQuery } from "@iewcasia/Utilities/initialSiteLoadQuery";
import { removeCookie } from "@insite/client-framework/Common/Cookies";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { deleteSession, stopWatchingForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    CreateOrRequestQuote,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";

replaceInChain(chain, PopulateApiParameter, async props => {
    const quoteParameter = props.getState().pages.rfqRequestQuote.quoteParameter;
    const { quoteId, jobName, quoteType, accountId, note } = quoteParameter;
    props.apiParameter = {
        quoteId,
        jobName,
        isJobQuote: quoteType === "job",
        userId: accountId,
        note,
    };

    const initialSiteLoad = getInitialSiteLoadQuery();
    if (initialSiteLoad?.queryParams) {
        for (const [key, raw] of Object.entries(initialSiteLoad.queryParams)) {
            if (raw === "" || (Array.isArray(raw) && raw.length === 0)) {
                continue;
            }
            (props.apiParameter as any)[key] = Array.isArray(raw) ? raw.join(",") : raw;
        }
    }

    // eslint-disable-next-line no-console
    console.log("apiParameter", { ...props.apiParameter });
});

replaceInChain(chain, CreateOrRequestQuote, async props => {
    const { parameter, apiParameter } = props;
    const isGuest = props.getState().context.session.isGuest;

    // Verndale Customization: We call a custom api for all quotes created by guests or users
    // This api will create a quote as an "order" in the backend, since this project doesn't use the "quote" functionality
    const customResult = await customCreateQuote(apiParameter);

    if (customResult?.successful) {
        props.apiResult = customResult.result;
    } else {
        parameter.onError?.(customResult.errorMessage);
        return false;
    }

    const cartResult = await getCart({
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["cartLines"],
    } as GetCartApiParameter);

    // Verndale Customization: we remove some cookies that prevent the guest the user from creating a quote again
    // if there are pending items in the cart (not quote) ,we dont remove the cookies
    // if (isGuest && cartResult.cart?.cartLines?.length === 0) {
    // stopWatchingForOtherTabSessionChange(); // Prevent reload caused by this sign-out, which could interfere with the RedirectToHomePage step.
    // removeCookie("NavigationMode");
    // deleteSession();
    // }

    clearInitialSiteLoadQuery();
});
